import { lazy } from 'solid-js'
import { ROUTES } from '../router-utils.js'
import { messages } from '../../pages/referral-page/referral-page-routing.messages.en.js'

const PgReferralPage = lazy(() => import('../../pages/referral-page/referral-page.jsx'))

export default {
    component: PgReferralPage,
    descriptionMessage: messages.descriptionMessage,
    path: `${ROUTES.REFER}/:code`,
    showFooter: true,
    showHeaderMenu: true,
    titleMessage: messages.titleMessage,
}
